// router.ts
import { createRouter, createWebHistory } from 'vue-router'
import { useProjectStore } from '@/stores/projectStore'

import Login    from '@/views/Login.vue'
import Home     from '@/views/Home.vue'
import Register from '@/views/Register.vue'
import NotFound from '@/views/NotFound.vue'
import ForgotPassword from "@/views/ForgotPassword.vue"
import ChangePassword from "@/views/ChangePassword.vue"

import ProjectList from "@/views/ProjectList.vue"
import ProjectDashboard from "@/views/ProjectDashboard.vue"
import ProjectDetails from "@/views/ProjectDetails.vue"
import ProjectCalc from "@/views/ProjectCalc.vue"
import ProjectCalcValeri from "@/views/ProjectCalcValeri.vue"
import ProjectBenchmarking from "@/views/ProjectBenchmarking.vue"
import ProjectEnergyFlow from "@/views/ProjectEnergyFlow.vue"
import ProjectReports from "@/views/ProjectReports.vue"
import ShareProject from "@/views/ShareProject.vue"

import Action from "@/views/Action.vue"

import About   from "@/views/About.vue"
import Imprint from "@/views/Imprint.vue"
import Contact from "@/views/Contact.vue"



const routes = [
  { path: '/login', name: 'Login', component: Login, meta: { public: true } },
  { path: "/login/forgot-Password/", name: "ForgotPassword", component: ForgotPassword, meta: { public: true } },
  { path: '/register', name: 'Register', component: Register, meta: { public: true } },
  { path: '/', name: 'Home', component: Home, meta: { public: true, resetsProjectTitle: true } },
  { path: '/password/change_password', name: 'ChangePassword', component: ChangePassword, meta: { requiresAuth: true, resetsProjectTitle: true }},


  { path: "/projects", name: "ProjectList", component: ProjectList, meta: { resetsProjectTitle: true } },
  { path: "/project/:projectId", name: "ProjectDashboard", component: ProjectDashboard, meta: { requiresAuth: true } },
  { path: "/project/:projectId/details", name: "ProjectDetails", component: ProjectDetails, meta: { requiresAuth: true } },
  { path: "/project/new", name: "NewProject", component: ProjectDetails, meta: { requiresAuth: true } },
  { path: "/project/:projectId/calc", name: "ProjectCalc", component: ProjectCalc, meta: { requiresAuth: true } },
  { path: "/project/:projectId/benchmarking", name: "ProjectBenchmarking", component: ProjectBenchmarking, meta: { requiresAuth: true } },
  { path: "/project/:projectId/valeri", name: "ProjectCalcValeri", component: ProjectCalcValeri, meta: { requiresAuth: true } },
  { path: "/project/:projectId/energy-flow", name: "ProjectEnergyFlow", component: ProjectEnergyFlow, meta: { requiresAuth: true } },
  { path: "/project/:projectId/reports", name: "ProjectReports", component: ProjectReports, meta: { requiresAuth: true } },

  { path: "/project/:projectId/action/:actionId", name: "Action", component: Action, meta: { requiresAuth: true } },
  { path: "/project/:projectId/action/new", name: "NewAction", component: Action, meta: { requiresAuth: true } },

  { path: "/project/:projectId/share", name: "ShareProject", component: ShareProject, meta: { requiresAuth: true } },
  
  { path: "/about", name: "About", component: About },
  { path: "/contact", name: "Contact", component: Contact },
  { path: "/imprint", name: "Imprint", component: Imprint },

  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound, meta: { public: true } },
]

const router = createRouter({
  // App routes are served at '/' by Django's SPA catch-all; keep the router
  // base at '/' independent of the vite asset base ('/static/' in prod build),
  // otherwise deep-link reloads land on '/static/...' and 404.
  history: createWebHistory('/'),
  routes,
})

// Use the recommended return style in Vue Router 4
router.beforeEach(async (to) => {
  const store = useProjectStore()

  // Ensure auth state is ready before deciding
  if (!store.ready) {
    await store.init()
  }

  
  if (to.name === 'ForgotPassword') {
    if (!store.isLoggedIn || !store.forgotPassword) {
      // Not coming from OTP flow → send to Login
      return { name: 'Login', replace: true }
    }
  }


  // If the user is authenticated and must change password, force ForgotPassword
  if (store.isLoggedIn && store.forgotPassword && to.name !== 'ForgotPassword') {
    return { name: 'ForgotPassword', replace: true }
  }



  if (to.meta?.requiresAuth && !store.isLoggedIn) {
    return { name: 'Login', query: { redirect: to.fullPath }, replace: true }
  }

  // if (to.meta?.guestOnly && store.isLoggedIn) {
  //   return { name: 'ForgotPassword' }
  // }

  // else allow
})

export default router